import { ExtendedContextStore, Bandit, BanditPayload } from "src/typings/flexFramework/FlexDefinitions";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";
import { toJS } from "mobx";

export interface MABMicroMessage {
  schemaName: string;
  messageContent: {
    banditId: string;
    banditPayloads: BanditPayload[];
    events: any[];
  };
}

export enum MABPlatform {
  Desktop = "Desktop",
  Mobile = "Mobile",
  Tablet = "Tablet",
}

export function getMABMicroMessage(
  banditContext: Bandit,
  eventTarget: string,
  eventType: string,
  platform: MABPlatform,
  siteid: string | number
): MABMicroMessage {
  //const mabContext = viewModel.bandit;
  const nowDate = new Date();
  const { banditId, banditPayloads } = banditContext;
  const sortedPayloads = toJS(banditPayloads).map((payload) => {
    payload.arm.sort((a, b) => {
      if (a.categoryName < b.categoryName) {
        return -1;
      }

      if (a.categoryName > b.categoryName) {
        return 1;
      }

      return 0;
    });

    return payload;
  });
  sortedPayloads[0].context.push(
    {
      categoryName: "hourDay",
      level: `hod${nowDate.getUTCHours().toString()}`,
    },
    {
      categoryName: "siteid",
      level: siteid.toString(),
    }
  );
  const { banditPayloadId } = sortedPayloads[0] || {};
  const mabAnalyticsInfo: MABMicroMessage = {
    schemaName: "contextualMultiArmedBandit",
    messageContent: {
      banditId,
      banditPayloads: sortedPayloads,
      events: [
        {
          banditPayloadId,
          eventType,
          eventTarget,
          eventProperties: [
            {
              name: "Platform",
              value: platform,
            },
          ],
          banditDisplayed: true,
          eventCreationDateTime: `${nowDate.toISOString().split(".")[0]}Z`,
        },
      ],
    },
  };

  return mabAnalyticsInfo;
}

export function isMABEnabled(context: ExtendedContextStore): boolean {
  return isVariantEnabled(context, Experiment.Feature_Gate_MAB_on_SF);
}
